import { supabase } from '@/integrations/supabase/client';

interface GenerateJoinLinkResponse {
  token: string;
  join_url: string;
}

interface ClaimJoinLinkResponse {
  success: boolean;
  club_id: string;
  club_name: string;
  already_member?: boolean;
}

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL as string;

async function getAuthHeader(): Promise<string | null> {
  const { data: { session } } = await supabase.auth.getSession();
  return session?.access_token ? `Bearer ${session.access_token}` : null;
}

export const clubJoinLinkService = {
  async generateJoinLink(clubId: string): Promise<GenerateJoinLinkResponse> {
    const authHeader = await getAuthHeader();
    if (!authHeader) throw new Error('Not authenticated');

    const res = await fetch(`${SUPABASE_URL}/functions/v1/generate_club_join_link`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: authHeader,
      },
      body: JSON.stringify({ club_id: clubId }),
    });

    const data = await res.json();
    if (!res.ok) throw new Error(data.error ?? 'Failed to generate join link');
    return data as GenerateJoinLinkResponse;
  },

  async claimJoinLink(token: string): Promise<ClaimJoinLinkResponse> {
    const authHeader = await getAuthHeader();
    if (!authHeader) throw new Error('Not authenticated');

    const res = await fetch(`${SUPABASE_URL}/functions/v1/claim_club_join_link`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: authHeader,
      },
      body: JSON.stringify({ token }),
    });

    const data = await res.json();
    if (!res.ok) throw new Error(data.error ?? 'Failed to claim join link');
    return data as ClaimJoinLinkResponse;
  },
};
